<template>
  <section :class="$b()">
    <div :class="[$b('inner'), 'global-wrapper']">
      <BaseHeading
        tag="h4"
        size="h2"
        :class="$b('body')"
      >
        {{ quote }}”
      </BaseHeading>
      <BaseCopy
        tag="p"
        size="body"
      >
        {{ quoteAttribution }}
      </BaseCopy>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GradientQuote',

  props: {
    quote: {
      type: String,
      required: true,
    },
    quoteAttribution: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="postcss">
.GradientQuote {
  @apply text-white
    my-xl lg:my-xxl;
  background-image: var(--gradient-default);
}

.GradientQuote__inner {
  @apply py-lg lg:py-xxl;
}

.GradientQuote__body {
  @apply relative
    mb-sm;

  &:before {
    @apply absolute block;
    content: '\“';
    left: -0.5em;
  }
}
</style>
